import React from "react";
import "./Hero.css";
import Toolbar from "../Toolbar";
import BeachVideo from "./beach.mp4";

const Hero = (props) => {
  return (
    <div className="Hero">
      <Toolbar />
      <div className="img-content">
        <video
          className="image"
          src={BeachVideo}
          autoPlay
          muted
          loop
          playsInline
        ></video>
        <div className="gradient"></div>
      </div>
      <div className="text-body">
        <div className="text-content">
          <div className="header">SYKES & SYKES</div>
          <div className="subtitle">
            Your dream home is just around the corner.
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
